<template>
  <EditDialog
    v-model:visible="showModal"
    :title="
      $t('views.layout.Dialog.SureCancel.7ad2f02e063cd472f2737277f58583d7')
    "
    :width="595"
    :mask-closable="false"
    is-show-cancel
    :padding="30"
    @submit="handleSubmit"
    @cancel="handleCancel"
  >
    <div class="dialog-body">
      <div class="mb10">
        <div>
          {{
            $t(
              'views.layout.Dialog.SureCancel.0d54453e80c18c5a61635477c807c85e'
            )
          }}
        </div>
        <div>
          {{
            $t(
              'views.layout.Dialog.SureCancel.572e178180f2f9fa32cbd4e6ae3390cf'
            )
          }}
        </div>
      </div>
    </div>
  </EditDialog>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'CreateDataSet',
  components: {},
  emits: ['submit'],
  setup(_, { emit }) {
    const showModal = ref(false);

    const show = (flag = true) => {
      showModal.value = flag;
    };

    const handleSubmit = async () => {
      emit('submit');
    };
    const handleCancel = () => {
      showModal.value = false;
    };
    return {
      showModal,
      show,
      handleSubmit,
      handleCancel
    };
  }
});
</script>

<style scoped lang="less">
.feedback-btn {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  .btn {
    margin: 0 8px;
  }
}
</style>
